import { IconTile } from 'shared/components/icon-tile'
import React, { PropsWithChildren, ReactNode } from 'react'

interface DigitalProductSectionProps {
  action?: ReactNode
  description?: ReactNode
  icon: ReactNode
  title: ReactNode
}

/**
 * `Resources` / `Price plans` block of a digital product, used by the card and the add modal.
 */
export function DigitalProductSection({
  action,
  children,
  description,
  icon,
  title,
}: PropsWithChildren<DigitalProductSectionProps>) {
  return (
    <div className={'flex flex-col gap-4'}>
      <div className={'flex items-center justify-between gap-3'}>
        <div className={'flex items-center gap-2'}>
          <IconTile size={'m'} tone={'outline'}>
            {icon}
          </IconTile>
          <div className={'flex flex-col gap-1'}>
            <div className={'text-base font-semibold'}>{title}</div>
            {description && <p className={'text-text-secondary text-sm'}>{description}</p>}
          </div>
        </div>
        {action}
      </div>
      {children}
    </div>
  )
}
